<div class="del-dialog-root">
  <button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="del-content">
    <div class="icon-box" [ngClass]="data.state">
      <i-tabler
        *ngIf="data.state === 'confirm'"
        name="exclamation-circle"
      ></i-tabler>
      <i-tabler *ngIf="data.state === 'success'" name="circle-check"></i-tabler>
      <i-tabler *ngIf="data.state === 'error'" name="circle-x"></i-tabler>
    </div>
    <div class="text-box">
      <h3>{{ data.title }}</h3>
      <p [innerHTML]="data.message"></p>
      <div class="del-actions" [class.align-center]="data.state !== 'confirm'">
        <ng-container *ngIf="data.state === 'confirm'">
          <button class="btn-primary" (click)="onConfirm()">
            Sí, eliminar
          </button>
          <button class="btn-outline" (click)="onCancel()">Cancelar</button>
        </ng-container>
        <ng-container *ngIf="data.state === 'success'">
          <button class="btn-primary btn-center" (click)="onConfirm()">
            Aceptar
          </button>
        </ng-container>
        <ng-container *ngIf="data.state === 'error'">
          <button class="btn-primary btn-center" (click)="onConfirm()">
            Reintentar
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
